<template>
  <div>This is my menu panel</div>
</template>

<script>
export default {

}
</script>

<style>

</style>